export const PRODUCT_PAGE = 'product-page';
export const MOORING = 'MOORING';
